'use strict';

const Page = require('pages/Page/Page.js');

require('./PageIndex.less');

const Audio = require('components/Audio/Audio');
const IndexTitle = require('components/IndexTitle/IndexTitle');
const Footer = require('components/Footer/Footer');

const ChildViews = [
    {
        name: 'indexTitle',
        Constructor: IndexTitle
    },
    {
        name: 'audio',
        Constructor: Audio
    },
    {
        name: 'footer',
        Constructor: Footer
    }
];

module.exports = Page.extend({

    events: {},

    initialize: function (options = {}) {
        Page.prototype.initialize.call(this, options);

        this._initChildViews(ChildViews);
    }
});
